declare let THREE: any;

export class Selection extends (THREE.LineSegments as { new(geometry, material): any; }) {

  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(90));
  static readonly Name = 'selection';
  private boundingBox;

  constructor() {
    const geometry = new THREE.EdgesGeometry(new THREE.PlaneBufferGeometry(1, 1)
      .applyMatrix(Selection.rotationTransform));
    const material = new THREE.LineDashedMaterial({
      color: 0x00ff00,
      side: THREE.DoubleSide,
      dashSize: 0.1,
      gapSize: 0.03,
      depthTest: false,
      depthWrite: false
    });
    super(
      geometry,
      material
    );
    this.name = Selection.Name;
    this.boundingBox = new THREE.Box3();
    this.visible = false;
    this.renderOrder = 1;
  }

  update() {
    const objects = this.parent.getBoundingBoxObjects();
    const bb = objects.reduce((boundingBox, line) =>
      boundingBox.union(this.boundingBox.setFromObject(line)), new THREE.Box3());
    const size = new THREE.Vector3();
    const center = new THREE.Vector3();
    bb.getSize(size);
    bb.getCenter(center);
    this.position.copy(center.sub(this.parent.position));
    this.scale.copy(size.setY(1));
    this.computeLineDistances();
  }

  show() {
    this.update();
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Selection.ts